import { useMemo } from 'react'

import { useStatsigLayer } from 'hooks/use-statsig-layer'

const LAYER_ID = 'booking_flow'
const GOOGLE_PARAM = 'mutual_availability_sign_up_with_google'
const MICROSOFT_PARAM = 'mutual_availability_sign_up_with_microsoft'

export const useMutualAvailabilitySignupExperiment = () => {
  const layer = useStatsigLayer(LAYER_ID)

  return useMemo(() => {
    const isSignUpWithGoogle = layer ? layer.get(GOOGLE_PARAM, false) : false
    const isSignUpWithMicrosoft = layer ? layer.get(MICROSOFT_PARAM, false) : false

    return {
      isSignUpWithGoogle,
      isSignUpWithMicrosoft,
    }
  }, [layer])
}
